if (!customElements.get('skdg-card-variant-select')) {
  customElements.define(
    'skdg-card-variant-select',
    class SkdgCardVariantSelect extends HTMLElement {
      connectedCallback() {
        this.select = this.querySelector('select');
        this.select.addEventListener('change', this.onChange.bind(this));
      }

      onChange() {
        const card = this.closest('.card');
        const option = this.select.selectedOptions[0];
        const template = this.querySelector(`template[data-variant-price="${this.select.value}"]`);
        const price = card?.querySelector('.skdg-card-price');

        if (template && price) price.replaceWith(template.content.cloneNode(true));

        const button = this.closest('form')?.querySelector('[type="submit"]');
        if (!button) return;

        const soldOut = option.hasAttribute('data-sold-out');
        button.disabled = soldOut;
        button.removeAttribute('aria-disabled');
        const label = button.querySelector('.skdg-card__btn-label');
        if (label) label.textContent = soldOut ? this.dataset.soldOutLabel : this.dataset.addLabel;
      }
    }
  );
}
